
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/design-your-kitchen",
      function () {
        return require("private-next-pages/[region]/design-your-kitchen/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/design-your-kitchen"])
      });
    }
  